"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var useScroll = function useScroll(onScroll, parallaxChildrenRef) {
  (0, _react.useEffect)(function () {
    if (!onScroll) return;

    var handleScroll = function handleScroll() {
      return onScroll(window.pageYOffset);
    };

    window.addEventListener("scroll", handleScroll);
    var parallaxChildrenEl = parallaxChildrenRef && parallaxChildrenRef.current;

    var handleParallaxScroll = function handleParallaxScroll() {
      onScroll(parallaxChildrenEl.scrollTop);
    };

    if (parallaxChildrenEl) {
      parallaxChildrenEl.addEventListener("scroll", handleParallaxScroll);
      handleParallaxScroll();
    } else {
      handleScroll();
    }

    return function () {
      window.removeEventListener("scroll", handleScroll);

      if (parallaxChildrenEl) {
        parallaxChildrenEl.removeEventListener("scroll", handleParallaxScroll);
      }
    };
  }, [onScroll, parallaxChildrenRef]);
};

var _default = useScroll;
exports.default = _default;